module.exports = require("@ngx-translate/core");


//////////////////
// WEBPACK FOOTER
// external "@ngx-translate/core"
// module id = 79
// module chunks = 0